// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postDeviceAlertSettingsByDeviceId } from '../../services/DeviceService';
import { AlertsConfigurationRequest, AlertsConfiguration } from '../../types/Devices';

type Result = UseMutationResult<AlertsConfiguration, Error, AlertsConfigurationRequest>;

function usePostDeviceAlertSettingsByDeviceId(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(postDeviceAlertSettingsByDeviceId, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['device-alerts-settings'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePostDeviceAlertSettingsByDeviceId;
